module.exports = __webpack_public_path__ + "img/icon-copy-green.d2c671a9.svg";